<template>
  <v-card elevation="0" flat>
    <v-card-text class="pa-8 pt-4" style="max-height: 90vh; overflow-y: auto;">
      <p class="body-2 pt-0 mb-2">
        {{ t('accessibilityStatement.about') }}
      </p>
      <p class="body-2 mb-4">
        {{ t('accessibilityStatement.description') }}
      </p>
      <h3 class="headline mb-1 mt-4">
        {{ t('accessibilityStatement.contact.title') }}
      </h3>
      <p class="body-2 mb-2">
        {{ t('accessibilityStatement.contact.description') }}
      </p>

      <p class="mb-0">
        <a
          :href="'mailto:' + t('logoFooter.supportEmail')"
          :aria-label="t('accessibilityStatement.contact.emailLabel', { email: t('logoFooter.supportEmail') })"
          class="primary--text"
        >
          {{ t('logoFooter.supportEmail') }}
        </a>
      </p>
      <p class="mb-4">
        <a
          :href="'tel:' + t('logoFooter.supportPhone')"
          :aria-label="t('accessibilityStatement.contact.phoneLabel', { email: t('logoFooter.supportPhone') })"
          class="primary--text"
        >
          {{ t('logoFooter.supportPhone') }}
        </a>
      </p>
      <h3 class="headline mb-1 mt-0">
        {{ t('accessibilityStatement.knownIssues.title') }}
      </h3>
      <v-list dense two-line>
        <span class="body-2 mb-0 d-block">
          {{ t('accessibilityStatement.knownIssues.text') }}
        </span>
        <v-list-item
          v-for="(section, index) in items"
          :key="index"
          class="mb-0"
        >
          <v-list-item-content>
            <v-list-item-title class="subtitle-2 mb-0">
              {{ section.title }}
            </v-list-item-title>
            <v-list dense>
              <v-list-item
                v-for="(issue, idx) in section.issues"
                :key="idx"
                class="pb-1"
              >
                <v-list-item-content>
                  <div class="body-2 mb-0">
                    {{ issue.text }}
                  </div>
                  <div class="text--secondary text-caption">
                    [{{ issue.wcag }} {{ issue.description }}]
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <h3 class="headline mb-1 mt-0">
        {{ t('accessibilityStatement.actionPlan') }}
      </h3>
      <p class="body-2 mb-4">
        {{ t('accessibilityStatement.ongoingWork') }}
      </p>
      <p class="body-2 mb-4">
        {{ t('accessibilityStatement.endGoal') }}
      </p>
      <div class="text-right mt-4 mb-4">
        <p class="subtitle-2">
          {{ t('accessibilityStatement.updatedAt', { date: '2025-07-31' }) }}
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLabel } from '@/composables/useLabel';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {},
  setup() {
    const { t } = useLabel();
    const { tm } = useI18n();

    // Use tm() to get the raw translation object including arrays
    const items = computed(() => {
      const section = tm('accessibilityStatement.section.information');
      if (!section || !section.issues) return [];
      return [{ title: section.title, issues: section.issues }];
    });

    return { t, items };
  },
});
</script>